const COMPONENT_NAME = "Strip";
const INVALID_PROPS_ERROR = `${COMPONENT_NAME}-error: Missing required parameter children`;
export {
  COMPONENT_NAME,
  INVALID_PROPS_ERROR
};
